import { useNavigate } from '@tanstack/router'
import axios from 'axios'
import { useEffect, useState } from 'react'

import useCommonEmblaCarousel from '../../hooks/useCommonEmblaCarousel'
import type { ApiResponse } from '../../types/api'
import type { PromotionObj } from '../../types/promotion'
import { api } from '../../utils/api-client'
import { kebabCase } from '../../utils/string'
import Icon from '../icon'
import { Button } from './sliderStyles'

const PromotionsSlider = () => {
  const [emblaRef] = useCommonEmblaCarousel()
  const navigate = useNavigate({ from: '/' })
  const [promoList, setPromoList] = useState<PromotionObj[]>([])

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    const getPromotions = async () => {
      try {
        const response = await api.post<ApiResponse<PromotionObj[]>>(
          '/ajax_check.php',
          {
            type: 'get_promotion_list',
          },
          { signal },
        )

        const { status, info } = response.data
        if (status === 1) {
          setPromoList(info)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error)
        }
      }
    }

    getPromotions()

    return () => {
      controller.abort()
    }
  }, [])

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container -ml-2.5 lg:-ml-5">
        {promoList.map(promo => (
          <div
            key={promo.id}
            className="pl-2.5 lg:pl-5 embla__slide lg:flex-[0_0_calc(100%_/_3)]">
            <div className="relative flex-1 bg-white flex p-1 rounded-[25px]">
              <img
                className="w-full h-full object-cover rounded-[25px]"
                src={promo.bannerurl}
                style={{ aspectRatio: '2' }}
                alt={promo.title}
              />
              <Button
                onClick={() => {
                  navigate({
                    to: '/promotions/$promoId',
                    params: {
                      promoId: `${promo.id}-${kebabCase(promo.title)}`,
                    },
                  })
                }}>
                <Icon id="arrow-right" width="12" height="11" fill="#000" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PromotionsSlider
